import { Form, Button, InputGroup, Alert, Collapse } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { setIsLoading } from '../general/actions';
import { currencyFormater } from '../general/utils';
import AlertModal from '../general/alertModal';
import { HOST } from '../general/utils';
import SelectAgreement from '../general/selectAgreement';
import { C, barColor } from '../general/colors';

function FundsList(props) {
    const { setIsLoading, agreement } = props;

    const [items, setItems] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [agreementFilter, setAgreementFilter] = useState(agreement || '');
    const [openBulkUpload, setOpenBulkUpload] = useState(false);
    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => { props.setIsCreation(false); }, []);

    const getList = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get(`/funds/agreements/${agreementFilter}`);
            setItems(response.data);
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalType('danger');
            setAlertModalMsg(error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };

    const bulkUpload = async (e) => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('file', e.target.files[0]);
        e.target.value = null;
        try {
            await axiosInstance.post('/funds/import-csv', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            getList();
            setAlertModalShow(true);
            setAlertModalType('success');
            setAlertModalMsg('Fondos creados correctamente');
        } catch (error) {
            setAlertModalShow(true);
            setAlertModalType('danger');
            const msg = 'No se creó ningún fondo: ';
            if (error.response.data.message.includes('Duplicate')) setAlertModalMsg(msg + 'Ext ID ya existe en el sistema.');
            else if (error.response.data.message.includes('agreement')) setAlertModalMsg(msg + 'Contrato inválido en el archivo.');
            else setAlertModalMsg(msg + error.response.data.message);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (agreementFilter) {
            getList();
            props.setAgreement(agreementFilter);
        } else {
            setItems([]);
            setMessage('Selecciona un contrato para ver los fondos');
        }
    }, [agreementFilter]);

    const filtered = items.filter(item =>
        (item.name?.toLowerCase().includes(searchText.toLowerCase())) ||
        (item.description?.toLowerCase().includes(searchText.toLowerCase())) ||
        (String(item.ext_id).includes(searchText))
    );

    return (
        <>
            <div className="order-section">
                <div className="order-section-header" style={{ justifyContent: 'space-between' }}>
                    <span><i className="fa fa-money" /> Fondos</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                        {agreementFilter && (
                            <Button size="sm" variant="primary" onClick={() => props.setIsCreation(true)}>
                                <i className="fa fa-plus" /> Crear
                            </Button>
                        )}
                        <Button size="sm" variant="outline-secondary"
                            onClick={() => setOpenBulkUpload(v => !v)}
                            aria-controls="bulk-funds"
                        >
                            <i className="fa fa-upload" /> Carga masiva
                        </Button>
                    </div>
                </div>

                <Collapse in={openBulkUpload}>
                    <div id="bulk-funds" className="order-section-body" style={{ background: '#f8fafc', borderBottom: '1px solid var(--abi-border)', fontSize: 13 }}>
                        Descarga la plantilla{' '}
                        <a href={HOST + 'storage/files/funds.csv'} target="_blank" rel="noreferrer">funds.csv</a>
                        , complétala y sube el archivo:
                        <Form.Control type="file" accept=".csv" size="sm" className="mt-2" style={{ maxWidth: 280 }}
                            onChange={(e) => bulkUpload(e)} />
                    </div>
                </Collapse>

                <div className="order-section-body" style={{ paddingBottom: 0 }}>
                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 12, alignItems: 'center' }}>
                        <div style={{ minWidth: 260, flex: 2 }}>
                            <SelectAgreement agreement={agreementFilter} setAgreement={setAgreementFilter} disabled={false} />
                        </div>
                        <InputGroup style={{ maxWidth: 260, flex: 1 }}>
                            <InputGroup.Text style={{ background: 'var(--abi-bg)', border: '1px solid var(--abi-border)', borderRight: 'none', fontSize: 12 }}>
                                <i className="fa fa-search" style={{ color: 'var(--abi-muted)' }} />
                            </InputGroup.Text>
                            <Form.Control
                                placeholder="Buscar fondo…" size="sm" value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{ borderLeft: 'none' }}
                            />
                            {searchText && (
                                <Button size="sm" variant="outline-secondary" onClick={() => setSearchText('')}>
                                    <i className="fa fa-times" />
                                </Button>
                            )}
                        </InputGroup>
                        {items.length > 0 && (
                            <span className="report-count"><strong>{filtered.length}</strong> de <strong>{items.length}</strong></span>
                        )}
                    </div>
                </div>

                {message && !agreementFilter && (
                    <div className="order-section-body">
                        <Alert variant="info" className="mb-0 py-2" style={{ fontSize: 13 }}>{message}</Alert>
                    </div>
                )}

                {filtered.length > 0 && (
                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                    <table className="report-table mb-0" style={{ width: '100%', borderRadius: 0, border: 'none', minWidth: 720 }}>
                        <thead>
                            <tr>
                                <th>Fondo</th>
                                <th>Nombre</th>
                                <th>Centro de costos</th>
                                <th>Valor Inicial</th>
                                <th>Consumo</th>
                                <th>Disponible</th>
                                <th>Estado</th>
                                <th>Usuarios</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map(item => {
                                const pct = item.amount > 0 ? Math.min(100, (item.spent / item.amount) * 100) : 0;
                                const fundColor = barColor(pct);
                                return (
                                    <React.Fragment key={'fund-' + item.id}>
                                        <tr>
                                            <td>
                                                <div style={{ fontWeight: 700, color: 'var(--abi-primary)', fontSize: 12 }}>#{item.id}</div>
                                                <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>{item.ext_id}</div>
                                            </td>
                                            <td style={{ fontWeight: 600, fontSize: 13 }}>{item.name}</td>
                                            <td style={{ fontSize: 12 }}>{item.department?.name}</td>
                                            <td>
                                                <div style={{ fontWeight: 600 }}>{currencyFormater(item.amount)}</div>
                                                <div className="report-fund-bar-wrap" style={{ marginTop: 4 }}>
                                                    <div className="report-fund-bar-fill" style={{ width: `${pct}%`, background: fundColor }} />
                                                </div>
                                                <div style={{ fontSize: 10, color: fundColor, fontWeight: 700, marginTop: 2 }}>{pct.toFixed(0)}%</div>
                                            </td>
                                            <td>{currencyFormater(item.spent)}</td>
                                            <td style={{ fontWeight: 700, color: parseFloat(item.available) <= 0 ? C.danger : C.success }}>
                                                {currencyFormater(item.available)}
                                            </td>
                                            <td>
                                                <span className="report-status-badge" style={
                                                    item.is_active
                                                        ? { background: '#dcfce7', color: '#166534', border: '1px solid #86efac' }
                                                        : { background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }
                                                }>
                                                    {item.is_active ? 'Activo' : 'Inactivo'}
                                                </span>
                                            </td>
                                            <td style={{ fontSize: 12, color: 'var(--abi-muted)' }}>
                                                {item.user_fund?.length > 0 ? `${item.user_fund.length} usuario${item.user_fund.length > 1 ? 's' : ''}` : '—'}
                                            </td>
                                            <td>
                                                <button className="report-icon-btn" title="Editar" onClick={() => props.setEditData(item)}>
                                                    <i className="fa fa-pencil" />
                                                </button>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                    </div>
                )}
            </div>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(FundsList);
